import React from "react";
import "./../styles/global.scss";
import NavbarCustom from "./../components/NavbarCustom";
import IndexPage from "./index";
import CoffeePage from "./coffeePage";
import coffeeCard from "./coffeeCard";
import AddCoffeePage from "./add";
import Search from "./search";
import DashboardPage from "./dashboard";
import SettingsPage from "./settings";
import AuthPage from "./auth";
import FirebaseActionPage from "./firebase-action.js";
import { Switch, Route, Router } from "./../util/router.js";
import NotFoundPage from "./not-found.js";
import { ProvideAuth } from "./../util/auth.js";

function App(props) {
    return (
    <ProvideAuth>
      <Router>
        
        <NavbarCustom /> 
        
        <Switch>
          <Route exact path="/" component={IndexPage} />

          <Route exact path="/coffee" component={coffeeCard} />

          <Route exact path="/c/:coffeeId" component={CoffeePage} />
          
          <Route exact path="/add" component={AddCoffeePage} />
          
          <Route exact path="/search" component={Search} />

          <Route exact path="/dashboard" component={DashboardPage} />

          <Route exact path="/settings/:section" component={SettingsPage} />

          <Route exact path="/profile" component={AuthPage} />

          <Route exact path="/auth/:type" component={AuthPage} />

          <Route
              exact
              path="/firebase-action"
              component={FirebaseActionPage}
            />
                    
          <Route component={NotFoundPage} />
        </Switch>

      </Router>
    </ProvideAuth>
  );
}

export default App;
